import React from 'react';
import Container from 'atomic/utilization/container';
import BreadcrumbsInterface from 'interfaces/breadcrumbs.interface';
import BreadcrumbsDropdown from 'components/utilization/breadcrumbs/components/breadcrumbs-dropdown';
import './breadcrumbs.desktop.scss';
import BreadcrumbsStructuralData from 'components/utilization/breadcrumbs/components/breadcrumbs-structural-data';

const BreadcrumbsDesktop: React.FC<{breadcrumbs: BreadcrumbsInterface[];}> = ({ breadcrumbs }) => {
    if (breadcrumbs.length === 0) {
        return null;
    }

    return (
        <>
            <nav className="breadcrumbs__content">
                <Container>
                    <div className="breadcrumbs">
                        {
                            breadcrumbs.map(breadcrumb => (
                                <div key={breadcrumb.id} className="breadcrumbs__item">
                                    {
                                        breadcrumb.url
                                            ? (
                                                <a
                                                    href={breadcrumb.url}
                                                    aria-label={breadcrumb.name}
                                                    className="breadcrumbs__item__link"
                                                >
                                                    {breadcrumb.prefix && (
                                                        <span>
                                                            {breadcrumb.prefix}
                                                            {': '}
                                                        </span>
                                                    )}
                                                    {breadcrumb.icon
                                                        ? (
                                                            <i className={breadcrumb.icon}/>
                                                        )
                                                        : (
                                                            breadcrumb.name
                                                        )}
                                                </a>
                                            )
                                            : (
                                                <>
                                                    {breadcrumb.prefix && (
                                                        <span>
                                                            {breadcrumb.prefix}
                                                            {': '}
                                                        </span>
                                                    )}
                                                    {breadcrumb.name}
                                                </>
                                            )
                                    }

                                    {
                                        breadcrumb.items && <BreadcrumbsDropdown items={breadcrumb.items}/>
                                    }

                                </div>
                            ))
                        }
                    </div>
                </Container>
            </nav>
            <BreadcrumbsStructuralData breadcrumbs={breadcrumbs}/>
        </>
    );
};

export default BreadcrumbsDesktop;
